export enum EResources {
  'news-management' = 1,
  'announcements-management',
  'album-management',
  'contact-messages',
}
